import { getValueAtPath } from "../../../../../utils";
import ViewFactory from "../../../helpers/viewfactory";
import ConfirmView from "./confirm";
import SuccessView from "../../../common/success";

export default function view() {
    const $this = this;
    const { $charge, $timer } = this;

    $this.pollConfig = {
        onBegin() {},
        onCancel() { $this.pollConfig.onComplete() },
        onFailure(data) {},
        onSuccessful() { SuccessView && SuccessView.activate.call($this) },
        onComplete() { $this.SHOULD_VALIDATE_CHARGE = false, $timer.clear() }
    }

        return (view = ViewFactory({
            NAME: 'CAPITEC_DETAILS_VIEW',
            mutables: { timerCurrent: 'CURRENT_TIME' },
            constants: {
                hasBackAction: false,
                get timerDuration() { return $timer.duration }
            },
            next() {
                const hasStartedPolling = getValueAtPath($this, 'STATE.backgroundProcessing');
                const currency = getValueAtPath($this, 'STATE.currency.current');

                if (hasStartedPolling === false && currency === 'ZAR') {
                    ConfirmView && ConfirmView.activate(() => {
                        $charge.poll($this.pollConfig);
                    });
                }
            }
        }).call(this)
    )
}